export const MERCHANT = 'MERCHANT'
export const LINEHAUL = 'LINEHAUL'
export const LOCKER = 'LOCKER'

export default () => [
    { value: MERCHANT, label: 'Merchant' },
    { value: LINEHAUL, label: 'Linehaul' },
    { value: LOCKER, label: 'Locker' },
]
